module.exports = __webpack_public_path__ + "static/media/30OIOS2.c2584d89.jpg";